<div>
  <form [formGroup]="attributeFormGroup">
    <div style="display: flex; flex-direction: column; padding: 10px;">
      <mat-form-field>
        <input matInput placeholder="Attribute 1" formControlName="attribute1">
        @if (attributeFormGroup.controls.attribute1.hasError('required')) {
          <mat-error>
            Attribute 1 is required
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Attribute 2" formControlName="attribute2">
        @if (attributeFormGroup.controls.attribute2.hasError('required')) {
          <mat-error>
            Attribute 2 is required
          </mat-error>
        }
      </mat-form-field>
    </div>
  </form>
</div>

